<template>
    <div>
        <page-title>站点管理</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/host/auth-warning">授权警告</router-link>
                    </div>
                    <div>
                        <el-form :inline="true">
                            <el-form-item style="margin-bottom: 0; max-width: 80px">
                                <el-select v-model="status" clearable size="mini" placeholder="状态" @change="search()">
                                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 80px">
                                <el-select v-model="type" clearable size="mini" placeholder="版本" @change="search()">
                                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 150px">
                                <el-input v-model="keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="名称/域名/服务器IP"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column width="400" prop="name" label="站点">
                    <template slot-scope="scope">
                        <div>{{scope.row.domain}}</div>
                        <div style="font-size: 12px;color: #909090">{{scope.row.name}}</div>
                        <div style="font-size: 12px;color: #909090">用户: {{scope.row.user.name}}</div>
                        <div style="font-size: 12px;color: #909090">M: {{scope.row.user.mobile}}, Q:
                            {{scope.row.user.qq}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="domain" label="服务器IP">
                    <template slot-scope="scope">
                        <template v-if="scope.row.hostIps.length > 10">
                            <div v-for="(item, index) in scope.row.hostIps" :key="item.id" v-if="index < 10">
                                {{item.ip}}
                            </div>
                            <el-button type="text" style="padding: 0;" @click="showAllIps(scope.row.hostIps)">更多...
                            </el-button>
                        </template>
                        <template v-else>
                            <div v-for="item in scope.row.hostIps" :key="item.id">{{item.ip}}</div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="插件">
                    <template slot-scope="scope">
                        <template v-if="scope.row.pluginOrdersCount">
                            <router-link :to="'/dashboard/admin/plugin-order/index?host_id=' + scope.row.id">
                                {{scope.row.pluginOrdersCount.value}}
                            </router-link>
                        </template>
                        <template v-else>0</template>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="授权状态">
                    <template slot-scope="scope">
                        <span style="color: #909399" v-if="scope.row.status===0">审核中</span>
                        <span style="color: #67C23A" v-else-if="scope.row.status===1">已授权</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="版本">
                    <template slot-scope="scope">
                        <template v-if="scope.row.type === 1">
                            <div>微擎版</div>
                            <div v-if="scope.row.we7_branch===1">自运营版</div>
                            <div v-if="scope.row.we7_branch===2">无限开版</div>
                        </template>
                        <template v-if="scope.row.type === 2">
                            <div>独立版</div>
                            <div>
                                <span>子账户: </span>
                                <span v-if="scope.row.account_num === -1">无限制</span>
                                <span v-else>{{scope.row.account_num}}个</span>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="时间">
                    <template slot-scope="scope">
                        <el-tooltip class="item" content="添加时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.add_time}}</div>
                        </el-tooltip>
                        <el-tooltip class="item" content="更新时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.update_time}}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <el-button type="text" v-if="scope.row.status === 0" @click="updateStatus(scope.row, 1)">
                                授权通过
                            </el-button>
                            <el-button type="text" v-else @click="updateStatus(scope.row, 0)">取消授权</el-button>
                            <span class="text-split">|</span>
                            <router-link :to="'/dashboard/admin/host/edit?id=' + scope.row.id">编辑</router-link>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="deleteHost(scope.row)">删除</el-button>
                        </template>
                        <template v-else>
                            <span style="color: #909399">已删除</span>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
            <el-dialog title="站点可用性检测" :fullscreen="true" :visible.sync="showHostTestDialog">
                <host-test></host-test>
            </el-dialog>
        </page-body>
    </div>
</template>

<style scoped>
@media screen and (max-width: 767px) {
    .list-header {
        padding: 0.5rem 0.2rem;
    }
}
</style>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    components: {
        'HostTest': () => import('@/components/HostTest.vue')
    },
    data() {
        return {
            showHostTestDialog: false,
            statusOptions: [
                {
                    value: 0,
                    label: '未授权'
                },
                {
                    value: 1,
                    label: '已授权'
                }
            ],
            typeOptions: [
                {
                    value: 1,
                    label: '微擎版'
                },
                {
                    value: 2,
                    label: '独立版'
                }
            ],
            loading: false,
            list: null,
            pagination: null,
            status: null,
            type: null,
            keyword: '',
            user_id: null
        }
    },
    created() {
        this.user_id = this.$route.query.user_id || null
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/host/index',
                    params: {
                        page: page,
                        status: this.status,
                        type: this.type,
                        keyword: this.keyword,
                        user_id: this.user_id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        showAllIps(ips) {
            let content = ''
            for (let i in ips) {
                content += `<div>${ips[i].ip}</div>`
            }
            this.$alert(content, '服务器IP', {
                dangerouslyUseHTMLString: true,
                callback: action => {
                }
            })
        },
        deleteHost(host) {
            new Promise(resolve => {
                this.$confirm('此操作将删除该站点, 是否继续?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(host)
                }).catch(() => {
                })
            }).then(host => {
                this.loading = true
                axios({
                    url: 'admin/host/delete',
                    params: {
                        id: host.id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        host.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        updateStatus(host, status) {
            let content = ''
            if (status === 0) {
                content = '是否确认取消授权？'
            } else {
                content = '是否确认授权通过？'
            }
            this.$confirm(content, '提示', {}).then(() => {
                const data = helper.clone(host)
                data.status = status
                data['host_ip_list'] = host.hostIps
                delete data.hostIps
                this.loading = true
                axios({
                    url: 'admin/host/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        host.status = status
                        this.$message.success('操作成功。')
                    } else {
                        host.status = status === 0 ? 1 : 0
                        this.$message.error(e.data.msg)
                    }
                })
            }).catch(() => {
            })
        }
    }
}
</script>
